// Components
import TodoList from './components/TodoList';

// MUI
import { createTheme, ThemeProvider } from '@mui/material/styles';
import rtlPlugin from '@mui/stylis-plugin-rtl';
import { prefixer } from 'stylis';
import { CacheProvider } from '@emotion/react';
import createCache from '@emotion/cache';

// Context
import TodosProvider from './contexts/TodosProvider';

function App() {

  // rtl direction
  const theme = createTheme({
    direction: 'rtl',
    typography: {
      fontFamily: "Alex"
    }
  });
  const cacheRtl = createCache({
    key: 'muirtl',
    stylisPlugins: [prefixer, rtlPlugin],
  });

  return (
    <TodosProvider>
      <CacheProvider value={cacheRtl}>
        <ThemeProvider theme={theme}>
          <div className="App" style={{
            display: "flex", justifyContent: "center", alignItems: "center",
            width: "100vw", height: "100vh", backgroundColor: "#202124"
          }}>
            <TodoList />
          </div>
        </ThemeProvider>
      </CacheProvider>
    </TodosProvider>
  );
}

export default App;